export default __webpack_public_path__ + "static/odciski-f4dd08006e362854d14b45a6c3ba7de3.png";